import styled, { css } from 'styled-components';

export const CheckboxWrapper = styled.label<{ disabled?: boolean }>`
  ${({ disabled = false }) => css`
    display: flex;
    align-items: center;
    cursor: ${disabled ? 'default' : 'pointer'};
    width: fit-content;
  `}
`;

export const CheckboxInput = styled.input`
  ${({ disabled = false }) => css`
    opacity: 0;
    cursor: ${disabled ? 'default' : 'pointer'};
    display: none;
  `}
`;

export const CheckboxCheckmark = styled.span`
  position: relative;
  display: inline-block;
  width: 25px;
  height: 25px;
  background-color: #a7a5a5;
  border-radius: 5px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  ${CheckboxInput}:checked + & {
    background-color: #11465d;
    border-color: #11465d;
  }

  ${CheckboxInput}:checked + &:after {
    content: '';
    position: absolute;
    left: 10px;
    top: 5px;
    width: 3px;
    height: 10px;
    border: solid white;
    border-width: 0 4px 4px 0;
    transform: rotate(45deg);
  }
`;

export const CheckboxLabel = styled.span<{ disabled?: boolean }>`
  ${({ disabled = false }) => css`
    margin-left: 10px;
    font-size: 17px;
    width: fit-content;
    color: ${disabled ? '#888888' : '#333'};
  `}
`;
